import { db } from "../connection";
import { collection, getDocs, doc, updateDoc, setDoc } from "firebase/firestore";

export async function fetchClubColors() {
  const snapshot = await getDocs(collection(db, "clubColors"));
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function saveClubColors(docId, data) {
  const { id, ...rest } = data;
  await updateDoc(doc(db, "clubColors", docId), rest);
}

export async function createClubColors(data) {
  const { clubId, ...rest } = data;
  await setDoc(doc(db, "clubColors", String(clubId)), { clubId, ...rest });
}
